// 字典选项缓存（客户/供应商/仓库/分类/员工/产品下拉共用）
// 独立成模块供 api 层在数据变更后调用失效，避免 api → composable 循环依赖

export interface SelectOption {
  id: number | string
  name: string
  [key: string]: any
}

const cache = new Map<string, SelectOption[]>()

export function getDictionaryCache(key: string): SelectOption[] | undefined {
  return cache.get(key)
}

export function setDictionaryCache(key: string, list: SelectOption[]): void {
  cache.set(key, list)
}

// 数据变更后调用：指定类型时同时清普通与含线索两个 key，无参清空全部
export function clearDictionaryCache(type?: string): void {
  if (type) {
    cache.delete(type)
    cache.delete(`${type}:leads`)
  } else {
    cache.clear()
  }
}
